"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Head = require("./Head");
Object.keys(_Head).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Head[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Head[key];
    }
  });
});
